<div class="pre-bootstrap">
  <!-- <div class="pre-bootstrap-text m-locate">
    <h6 class="title">{{message}}<sup><strong class="text-primary"></strong></sup></h6>
  </div>
  <div class="loader "></div> -->
  <app-progress></app-progress>
</div>
